import * as React from 'react';
import * as styles from './Skeleton.css';

export const Skeleton = () => {
  return <div className={styles['skeleton-q8sx1kczrff']} />;
};
